export enum Action {
  // org level
  ViewOrgSettings = 'ViewOrgSettings',
  ViewSubscriptionInfo = 'ViewSubscriptionInfo',
  InviteOrgMembers = 'InviteOrgMembers',
  RemoveOrgMember = 'RemoveOrgMember',
  UpdateOrgRoles = 'UpdateOrgRoles',
  UpdateOrgPermissions = 'UpdateOrgPermissions',
  UpdateCompanyLogo = 'UpdateCompanyLogo',
  ViewOrgTransactions = 'ViewOrgTransactions',
  ManageOrgLayerConfig = 'ManageOrgLayerConfig',

  // project level
  ViewAllProjects = 'ViewAllProjects',
  CreateProject = 'CreateProject',
  ViewProjectDetails = 'ViewProjectDetails',
  EditProjectDetails = 'EditProjectDetails',
  EditProjectBoundary = 'EditProjectBoundary',
  UpdateProjectPM = 'UpdateProjectPM',
  AddProjectMember = 'AddProjectMember',
  RemoveProjectMember = 'RemoveProjectMember',
  ArchiveProject = 'ArchiveProject',
  AddProjectFile = 'AddProjectFile',
  UpdateProjectFile = 'UpdateProjectFile',
  DeleteProjectFile = 'DeleteProjectFile',
  AddFieldData = 'AddFieldData',
  UpdateFieldData = 'UpdateFieldData',
  DeleteFieldData = 'DeleteFieldData',
  OrderFreeReports = 'OrderFreeReports',
  OrderPaidReports = 'OrderPaidReports',
  DownloadData = 'DownloadData',
  RequestMaps = 'RequestMaps',
  ExportOutreachLog = 'ExportOutreachLog',
  ViewCivilDraw = 'ViewCivilDraw',
  CreateCivilDraw = 'CreateCivilDraw',
  EditCivilDraw = 'EditCivilDraw',
  DeleteCivilDraw = 'DeleteCivilDraw',
  CommentCivilDraw = 'CommentCivilDraw',
  ViewProjectTransactions = 'ViewProjectTransactions',

  // mobile
  MobileViewAssets = 'MobileViewAssets',
  MobileAddData = 'MobileAddData',
  MobileEditData = 'MobileEditData',
  MobileDeleteData = 'MobileDeleteData',
}

class Authorizations {
  abilities: Set<Action> = new Set();

  setup(abilities: Action[]) {
    this.abilities = new Set(abilities);
  }

  can(action: Action): boolean {
    return this.abilities.has(action);
  }

  reset() {
    this.abilities.clear();
  }
}

const authorizations = new Authorizations();

export default authorizations;
